import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import List from './List';
import Create from './Create';
import Edit from './Edit';

export default {
  list: List,
  icon: ShoppingCartOutlinedIcon,
  create: Create,
  edit: Edit
};